import { render } from "./MobileBox.vue?vue&type=template&id=0a272fa8&scoped=true&bindings={\"yearlyFee\":\"props\",\"discountedYearlyFee\":\"props\",\"gains\":\"props\",\"profit\":\"props\",\"disclaimer\":\"props\"}"
import script from "./MobileBox.vue?vue&type=script&lang=js"
export * from "./MobileBox.vue?vue&type=script&lang=js"

import "./MobileBox.vue?vue&type=style&index=0&id=0a272fa8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a272fa8"

export default script